// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getOptionAnswerOpinometros as listOptionAnswersOpinometroAPI,
    getOptionAnswerOpinometro as getOptionAnswerOpinometroAPI,
    addOptionAnswerOpinometro as addOptionAnswerOpinometroAPI,
    updateOptionAnswerOpinometro as updateOptionAnswerOpinometroAPI,
    deleteOptionAnswerOpinometro as deleteOptionAnswerOpinometroAPI,
} from '../../helpers/';

import { optionAnswersOpinometroApiResponseError, optionAnswersOpinometroApiResponseSuccess } from './actions';
import { OptionAnswersOpinometroActionTypes } from './constants';

/**
 * Get option answer opinometro
 * @param {*} payload - username and password
 */
function* getOptionAnswerOpinometro({ payload: { id } }) {
    try {
        const response = yield call(getOptionAnswerOpinometroAPI, id);
        const optionAnswerItem = response.data.data;
        yield put(optionAnswersOpinometroApiResponseSuccess(OptionAnswersOpinometroActionTypes.GET_OPTION_ANSWER_OPINOMETRO, optionAnswerItem));
    } catch (error) {
        yield put(optionAnswersOpinometroApiResponseError(OptionAnswersOpinometroActionTypes.GET_OPTION_ANSWER_OPINOMETRO, error));
    }
}

function* addOptionAnswerOpinometro({ payload: optionAnswer }) {
    try {
        const response = yield call(addOptionAnswerOpinometroAPI, { ...optionAnswer })
        const optionAnswerItem = response.data
        yield put(optionAnswersOpinometroApiResponseSuccess(OptionAnswersOpinometroActionTypes.ADD_OPTION_ANSWER_OPINOMETRO, optionAnswerItem))
    } catch (error) {
        yield put(optionAnswersOpinometroApiResponseError(OptionAnswersOpinometroActionTypes.ADD_OPTION_ANSWER_OPINOMETRO, error))
    }
}

function* updateOptionAnswerOpinometro({ payload: optionAnswer }) {
    try {
        const response = yield call(updateOptionAnswerOpinometroAPI, { ...optionAnswer })
        const optionAnswerItem = response.data.data
        yield put(optionAnswersOpinometroApiResponseSuccess(OptionAnswersOpinometroActionTypes.UPDATE_OPTION_ANSWER_OPINOMETRO, optionAnswerItem))
    } catch (error) {
        yield put(optionAnswersOpinometroApiResponseError(OptionAnswersOpinometroActionTypes.UPDATE_OPTION_ANSWER_OPINOMETRO, error))
    }
}
function* deleteOptionAnswerOpinometro({ payload: { id } }) {
    try {
        const response = yield call(deleteOptionAnswerOpinometroAPI, id)
        const optionAnswerItem = response.data.id
        yield put(optionAnswersOpinometroApiResponseSuccess(OptionAnswersOpinometroActionTypes.DELETE_OPTION_ANSWER_OPINOMETRO, optionAnswerItem))
    } catch (error) {
        yield put(optionAnswersOpinometroApiResponseError(OptionAnswersOpinometroActionTypes.DELETE_OPTION_ANSWER_OPINOMETRO, error))
    }
}

/**
 * List contactos
 */
function* listOptionAnswersOpinometro({ payload: params }) {
    try {
        const response = yield call(listOptionAnswersOpinometroAPI, { ...params });
        const listaOptionAnswers = response.data.data;
        yield put(optionAnswersOpinometroApiResponseSuccess(OptionAnswersOpinometroActionTypes.LIST_OPTION_ANSWERS_OPINOMETRO, listaOptionAnswers));
    } catch (error) {
        yield put(optionAnswersOpinometroApiResponseError(OptionAnswersOpinometroActionTypes.LIST_OPTION_ANSWERS_OPINOMETRO, error));
    }
}


export function* watchGetOptionAnswerOpinometro(): any {
    yield takeEvery(OptionAnswersOpinometroActionTypes.GET_OPTION_ANSWER_OPINOMETRO, getOptionAnswerOpinometro);
}

export function* watchListOptionAnswersOpinometro(): any {
    yield takeEvery(OptionAnswersOpinometroActionTypes.LIST_OPTION_ANSWERS_OPINOMETRO, listOptionAnswersOpinometro);
}

export function* watchAddOptionAnswerOpinometro(): any {
    yield takeEvery(OptionAnswersOpinometroActionTypes.ADD_OPTION_ANSWER_OPINOMETRO, addOptionAnswerOpinometro)
}
export function* watchUpdateOptionAnswerOpinometro(): any {
    yield takeEvery(OptionAnswersOpinometroActionTypes.UPDATE_OPTION_ANSWER_OPINOMETRO, updateOptionAnswerOpinometro)
}
export function* watchDeleteOptionAnswerOpinometro(): any {
    yield takeEvery(OptionAnswersOpinometroActionTypes.DELETE_OPTION_ANSWER_OPINOMETRO, deleteOptionAnswerOpinometro)
}


function* optionAnswersOpinometroSaga(): any {
    yield all([
        fork(watchGetOptionAnswerOpinometro),
        fork(watchListOptionAnswersOpinometro),
        fork(watchAddOptionAnswerOpinometro),
        fork(watchUpdateOptionAnswerOpinometro),
        fork(watchDeleteOptionAnswerOpinometro),
    ]);
}

export default optionAnswersOpinometroSaga;
